<template>
  <v-flex xs12>
    <v-container>
      <form style="width: 100%">
        <v-layout :wrap="$vuetify.breakpoint.xsOnly" row justify-space-between>
          <v-flex xs12 sm6>
            <v-layout wrap row>
              <v-flex
                xs12
                pa-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>{{ $t('configuration.general_settings.information') }}</b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex v-show="working.wImage" xs3>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-flex>
                  <v-flex v-show="!working.wImage" xs12>
                    <v-layout
                      row
                      wrap
                      justify-center
                      v-on:mouseover="flags.updateImage = true"
                      v-on:mouseleave="flags.updateImage = false"
                    >
                      <v-flex
                        xs3
                        id="parentContainerLogoImage"
                        class="gradiente"
                        style="border-radius: 50%"
                        @click="modals.image = true"
                      >
                        <label id="img_edit_logo_default">
                          <v-img
                            :src="
                              require('@/assets/panel/modals/AddPhotoIcon@3x.png')
                            "
                          ></v-img>
                        </label>
                        <label id="img_edit_logo"></label>
                      </v-flex>
                      <v-flex xs12>
                        <v-expand-transition>
                          <v-btn
                            class="gradiente"
                            style="border-radius: 33px"
                            v-show="flags.updateImage"
                            dark
                            v-if="permits['UPDATE_SETTINGS']"
                            @click="
                              modals.image = true
                              modals.editImageTitle =
                                formBranch.img != ''
                                  ? $t(
                                      'configuration.general_settings.edit_image'
                                    )
                                  : $t(
                                      'configuration.general_settings.add_image'
                                    )
                            "
                          >
                            {{
                              $t('configuration.general_settings.update_logo')
                            }}
                          </v-btn>
                        </v-expand-transition>
                      </v-flex>
                      <v-flex xs12>
                        <v-expand-transition>
                          <v-btn
                            class="gradiente"
                            style="border-radius: 33px"
                            v-show="flags.updateImage && formBranch.qrimg != ''"
                            dark
                            v-if="permits['UPDATE_SETTINGS']"
                            @click="qrShow"
                          >
                            {{
                              $t('configuration.general_settings.college_qr')
                            }}
                          </v-btn>
                        </v-expand-transition>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('configuration.general_settings.name')"
                      required
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      v-model="formBranch.name"
                      :error-messages="nameErrors"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-switch
                      color="primary"
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      :label="
                        $t(
                          'configuration.general_settings.profile_editing_by_tutors'
                        )
                      "
                      v-model="formBranch.modifyingPermit"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="MODIFYING_PERMIT">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.profile_editing_by_tutors_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-switch
                      color="primary"
                      v-model="formBranch.photoOrigin"
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      :label="
                        $t(
                          'configuration.general_settings.student_editing_by_tutors'
                        )
                      "
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="PHOTO_ORIGIN">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.student_editing_by_tutors_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>Ingresos manuales</b>
                </label>
                <v-layout row wrap>
                  <v-flex xs10 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      label="Bloqueo de ingreso manual de alumnos"
                      v-model="formBranch.isStudentsActive"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs2 sm2>
                    <HelpTooltip data-name="LOCK_STUDENT_MANUAL_ATTENDANCE">
                      <span>
                        Esta opción te permite bloquear el ingreso manual de
                        alumnos en la app de Staff, a partir del número que se
                        establezca
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <v-expand-transition>
                    <v-layout row wrap v-show="formBranch.isStudentsActive">
                      <v-flex xs10 sm10>
                        <v-text-field
                          label="Número ingresos sin código QR al día."
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          type="number"
                          suffix="ingresos"
                          v-model="formBranch.studentsQty"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 sm2>
                        <HelpTooltip data-name="STUDENT_MANUAL_ATTENDANCE_QTY">
                          <span>
                            Establece el número de veces en los que se permitirá
                            ingresar un alumno sin código QR al día
                          </span>
                        </HelpTooltip>
                      </v-flex>
                    </v-layout>
                  </v-expand-transition>
                  <v-flex xs10 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      label="Bloqueo de ingreso manual de colaboradores"
                      v-model="formBranch.isCollaboratorsActive"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs2 sm2>
                    <HelpTooltip data-name="LOCK_STAFF_MANUAL_ATTENDANCE_QTY">
                      <span>
                        Esta opción te permite bloquear el ingreso manual de
                        colaboradores en la app de Staff, a partir del número
                        que se establezca
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <v-expand-transition>
                    <v-layout
                      row
                      wrap
                      v-show="formBranch.isCollaboratorsActive"
                    >
                      <v-flex xs10 sm10>
                        <v-text-field
                          label="Número ingresos sin código QR al día."
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          type="number"
                          suffix="ingresos"
                          v-model="formBranch.collaboratorsQty"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 sm2>
                        <HelpTooltip data-name="COLLAB_MANUAL_ATTENDANCE_QTY">
                          <span>
                            Establece el número de veces en los que se permitirá
                            ingresar un colaborador sin código QR al día
                          </span>
                        </HelpTooltip>
                      </v-flex>
                    </v-layout>
                  </v-expand-transition>
                </v-layout>
              </v-flex>

              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.requests.requests_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap justify-start>
                  <label
                    style="
                      font-weight: 500;
                      font-size: 14px;
                      color: rgba(0, 0, 0, 0.54);
                    "
                  >
                    {{
                      $t(
                        'configuration.general_settings.requests.range_of_time_to_apply_for_students'
                      )
                    }}
                  </label>
                  <v-flex xs12 sm10>
                    <v-radio-group
                      row
                      class="align-center"
                      v-model="formBranch.allDay"
                    >
                      <v-radio
                        :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                        color="primary"
                        :label="
                          $t('configuration.general_settings.requests.specify')
                        "
                        :value="false"
                      ></v-radio>
                      <v-radio
                        :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                        color="primary"
                        :label="
                          $t('configuration.general_settings.requests.all_day')
                        "
                        :value="true"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="ALL_DAY">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.requests.requests_help_1'
                          )
                        }}<br />
                        <ul>
                          <li>
                            <b>
                              {{
                                $t(
                                  'configuration.general_settings.requests.all_day'
                                )
                              }}
                            </b>
                            {{
                              $t(
                                'configuration.general_settings.requests.requests_help_2'
                              )
                            }}
                          </li>
                          <li>
                            <b>
                              {{
                                $t(
                                  'configuration.general_settings.requests.specify'
                                )
                              }}
                            </b>
                            {{
                              $t(
                                'configuration.general_settings.requests.requests_help_3'
                              )
                            }}
                          </li>
                        </ul>
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
                <v-expand-transition>
                  <v-layout row wrap justify-center v-show="!formBranch.allDay">
                    <v-flex xs12 sm10>
                      <v-subheader class="pl-0">
                        {{ formBranch.qTime }}
                        {{
                          $t(
                            'configuration.general_settings.requests.minutes_before_dismissal_time'
                          )
                        }}
                      </v-subheader>
                      <v-slider
                        thumb-label
                        v-model="formBranch.qTime"
                        max="360"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <HelpTooltip data-name="Q_TIME">
                        <span>
                          {{
                            $t(
                              'configuration.general_settings.requests.time_in_minutes_to_request_students_help_1_1'
                            )
                          }}
                          <b>
                            {{
                              $t(
                                'configuration.general_settings.requests.time_in_minutes_to_request_students_help_2_1'
                              )
                            }}
                          </b>
                          {{
                            $t(
                              'configuration.general_settings.requests.time_in_minutes_to_request_students_help_3'
                            )
                          }}
                          <br />
                          <br />
                          {{
                            $t(
                              'configuration.general_settings.requests.time_in_minutes_to_request_students_help_4'
                            )
                          }}
                        </span>
                      </HelpTooltip>
                    </v-flex>
                    <v-flex xs12 sm10>
                      <v-subheader class="pl-0">
                        {{ formBranch.eTime }}
                        {{
                          $t(
                            'configuration.general_settings.requests.minutes_after_dismissal_time'
                          )
                        }}
                      </v-subheader>
                      <v-slider
                        thumb-label
                        v-model="formBranch.eTime"
                        max="360"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <HelpTooltip data-name="E_TIME">
                        <span>
                          {{
                            $t(
                              'configuration.general_settings.requests.time_in_minutes_to_request_students_help_1_2'
                            )
                          }}
                          <b>
                            {{
                              $t(
                                'configuration.general_settings.requests.time_in_minutes_to_request_students_help_2_2'
                              )
                            }}
                          </b>
                          {{
                            $t(
                              'configuration.general_settings.requests.time_in_minutes_to_request_students_help_3'
                            )
                          }}
                          <br />
                          <br />
                          {{
                            $t(
                              'configuration.general_settings.requests.time_in_minutes_to_request_students_help_4'
                            )
                          }}
                        </span>
                      </HelpTooltip>
                    </v-flex>
                  </v-layout>
                </v-expand-transition>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm10>
                    <v-text-field
                      :label="
                        $t(
                          'configuration.general_settings.requests.time_to_request_again'
                        )
                      "
                      v-model="formBranch.studentTimeout"
                      type="number"
                      min="1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="STUDENT_DELIVER_TIMEOUT">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.requests.time_to_request_again_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex
                xs12
                pa-3
                mt-3
                row
                justify-space-between
                class="expandableContainer"
                v-show="permits['UPDATE_SETTINGS']"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.mail_servers.mail_servers_title'
                      )
                    }}
                  </b>
                </label>
                <v-container>
                  <v-layout row wrap justify-start>
                    <v-radio-group
                      row
                      style="align-center"
                      v-model="formBranch.email"
                    >
                      <v-flex xs12 sm10>
                        <v-radio
                          class="align-center"
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          color="primary"
                          :label="
                            $t(
                              'configuration.general_settings.mail_servers.skolable_mail'
                            )
                          "
                          :value="false"
                        ></v-radio>
                      </v-flex>
                      <v-flex xs12 sm2 style="text-align: end">
                        <HelpTooltip data-name="USE_CUSTOM_SMTP">
                          <span>
                            {{
                              $t(
                                'configuration.general_settings.mail_servers.skolable_mail_help'
                              )
                            }}
                          </span>
                        </HelpTooltip>
                      </v-flex>

                      <v-flex xs12 sm8 v-show="modelO">
                        <v-radio
                          class="align-center"
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          color="primary"
                          :label="emailForm.fromEmail"
                          :value="true"
                        ></v-radio>
                      </v-flex>
                      <v-flex
                        xs12
                        sm4
                        style="text-align: end"
                        v-show="modelO && formBranch.email"
                      >
                        <v-btn
                          class="helpButton"
                          fab
                          small
                          v-on:click="modelS = !modelS"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn
                          class="helpButton"
                          fab
                          small
                          @click="confirmDesition()"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-layout
                        row
                        wrap
                        justify-space-between
                        v-show="!modelO"
                        :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      >
                        <v-flex xs12 sm5 style="text-align: end">
                          <v-btn
                            dark
                            fab
                            small
                            class="helpButton"
                            color="gradiente"
                            v-on:click="modelS = !modelS"
                            >+</v-btn
                          >
                        </v-flex>
                        <v-flex
                          xs12
                          sm7
                          style="align-content: center; text-align: start"
                        >
                          <p>
                            {{
                              $t(
                                'configuration.general_settings.mail_servers.add_new_email'
                              )
                            }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-layout>

                  <v-layout
                    row
                    wrap
                    justify-space-between
                    v-show="modelS && (formBranch.email || !modelO)"
                    :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                  >
                    <v-flex xs6>
                      <v-text-field
                        :error-messages="userErrors"
                        v-model="$v.emailForm.user.$model"
                        required
                        :label="
                          $t('configuration.general_settings.mail_servers.user')
                        "
                      ></v-text-field>

                      <v-text-field
                        :error-messages="portErrors"
                        v-model="$v.emailForm.port.$model"
                        required
                        :label="
                          $t('configuration.general_settings.mail_servers.port')
                        "
                        type="number"
                      ></v-text-field>

                      <v-text-field
                        :error-messages="hostErrors"
                        v-model="$v.emailForm.host.$model"
                        required
                        :label="
                          $t('configuration.general_settings.mail_servers.host')
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        :error-messages="passwordErrors"
                        v-model="$v.emailForm.password.$model"
                        required
                        :label="
                          $t(
                            'configuration.general_settings.mail_servers.pasword'
                          )
                        "
                      ></v-text-field>

                      <v-text-field
                        :error-messages="emailErrors"
                        v-model="$v.emailForm.fromEmail.$model"
                        required
                        :label="
                          $t(
                            'configuration.general_settings.mail_servers.email'
                          )
                        "
                        type="email"
                      ></v-text-field>

                      <v-combobox
                        v-model="$v.emailForm.protocol.$model"
                        item-value="name"
                        required
                        :label="
                          $t(
                            'configuration.general_settings.mail_servers.protocol'
                          )
                        "
                        :items="protocolItems"
                      ></v-combobox>
                    </v-flex>
                    <v-btn
                      color="gradiente"
                      dark
                      round
                      v-on:click="modelS = !modelS"
                    >
                      {{
                        $t('configuration.general_settings.mail_servers.cancel')
                      }}
                    </v-btn>
                    <v-btn color="gradiente" dark round @click="submit">
                      {{
                        $t('configuration.general_settings.mail_servers.accept')
                      }}
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>Pase de salida de alumnos</b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      v-model="formBranch.checkoutAuthorization"
                      label="Pase de salida"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs2 ref="CHECKOUT_AUTHORIZATION">
                    <HelpTooltip data-name="CHECKOUT_AUTHORIZATION">
                      <span>
                        Activa el uso de pases de salida, lo que indica que los
                        alumnos no podrán hacer checkout hasta que el colegio o
                        el tutor les genere un pase de salida.
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.restart_transactions.restart_transactions_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm10>
                    <label>
                      {{
                        $t(
                          'configuration.general_settings.restart_transactions.restart_transactions_description_1'
                        )
                      }}
                    </label>
                    <br />
                    <label>
                      {{
                        $t(
                          'configuration.general_settings.restart_transactions.restart_transactions_description_2'
                        )
                      }}
                    </label>
                    <br />
                    <v-btn
                      :disabled="!permits['UPDATE_SETTINGS']"
                      @click="modals.desition = true"
                      color="gradiente"
                      dark
                      round
                    >
                      {{
                        $t(
                          'configuration.general_settings.restart_transactions.restart'
                        )
                      }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 :ml-4="!$vuetify.breakpoint.xsOnly">
            <v-layout row wrap>
              <v-flex
                xs12
                pa-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>Opciones de solicitudes de alumnos</b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      :label="
                        $t(
                          'configuration.general_settings.students_requests_settings.scan_on_arrive'
                        )
                      "
                      @click:append="arrivalCond()"
                      @change="arrivalCond"
                      v-model="formBranch.requestArrival"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="REQUEST_UPON_ARRIVAL">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.students_requests_settings.scan_on_arrive_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      :label="
                        $t(
                          'configuration.general_settings.students_requests_settings.activate_gps_assistance_for_requests'
                        )
                      "
                      @click:append="filterSearch(false)"
                      @change="filterSearch"
                      v-model="formBranch.gps"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="GPS_DELIVERY">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.students_requests_settings.activate_gps_assistance_for_requests_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <!-- <v-flex xs12 sm10>
										<v-switch
											:disabled="permits['UPDATE_SETTINGS'] ? false : true"
											color="primary"
											label="Usar Geolocalización"
											@click:append="filterSearch(false)"
											@change="filterSearch"
											v-model="formBranch.gps"
										></v-switch>
									</v-flex>
									<v-flex xs12 sm2>
										<v-btn dark fab small class="helpButton" color="gradiente" @click="help('GPS_DELIVERY')">?</v-btn>
									</v-flex> -->

                  <!-- <v-expand-transition>
										<v-flex xs12 sm6 v-show="formBranch.gps">
											<label>Basado en:</label>
											<v-radio-group v-model="formBranch.gpsType" row>
												<v-radio
													:disabled="permits['UPDATE_SETTINGS'] ? false : true"
													color="primary"
													label="Tiempo"
													value="time"
												></v-radio>
												<v-radio
													:disabled="permits['UPDATE_SETTINGS'] ? false : true"
													color="primary"
													label="Distancia"
													value="distance"
												></v-radio>
											</v-radio-group>
										</v-flex>
									</v-expand-transition> -->
                  <v-expand-transition mode="out-in">
                    <!-- <v-flex :key="1" xs12 sm4 v-if="formBranch.gpsType == 'time' && formBranch.gps">
											<label for="gpsTime">Minutos</label>
											<v-text-field
												:disabled="permits['UPDATE_SETTINGS'] ? false : true"
												type="number"
												id="gpsTime"
												v-model="formBranch.gpsTime"
												suffix="minutos"
												min="1"
												:error-messages="gpsTimeErrors"
											></v-text-field>
										</v-flex> -->
                    <!-- <v-flex :key="2" xs12 sm4 v-if="formBranch.gps">
											<label for="gpsDistance">Metros</label>
											<v-text-field
												type="number"
												:disabled="permits['UPDATE_SETTINGS'] ? false : true"
												id="gpsDistance"
												v-model="formBranch.gpsMeters"
												suffix="metros"
												min="1"
												:error-messages="gpsMetersErrors"
											></v-text-field>
										</v-flex> -->
                  </v-expand-transition>
                  <!-- <v-expand-transition>
										<v-flex xs12 sm2 v-show="formBranch.gps">
											<v-btn
												dark
												fab
												small
												class="helpButton"
												color="gradiente"
												@click="help('GPS_TIME_OR_DISTANCE')"
											>?</v-btn>
										</v-flex>
									</v-expand-transition> -->
                  <v-flex xs12>
                    <v-tooltip top>
                      <label slot="activator">
                        <a>
                          {{
                            $t(
                              'configuration.general_settings.students_requests_settings.advanced_options'
                            )
                          }}
                        </a>
                      </label>
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.students_requests_settings.advanced_options_help'
                          )
                        }}
                      </span>
                    </v-tooltip>
                  </v-flex>
                  <v-expand-transition>
                    <v-layout row wrap v-show="formBranch.gps">
                      <v-flex xs12 md3>
                        <v-text-field
                          :label="
                            $t(
                              'configuration.general_settings.students_requests_settings.maximum_waiting_time'
                            )
                          "
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          type="number"
                          :suffix="$t('configuration.seconds')"
                          v-model="formBranch.accurateTimeOut"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md3>
                        <HelpTooltip data-name="ACCURATE_LOCATION_TIME_OUT">
                          <span>
                            {{
                              $t(
                                'configuration.general_settings.students_requests_settings.maximum_waiting_time_help'
                              )
                            }}
                          </span>
                        </HelpTooltip>
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-text-field
                          :label="
                            $t(
                              'configuration.general_settings.students_requests_settings.accuracy_range'
                            )
                          "
                          type="number"
                          :suffix="$t('configuration.meters')"
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          v-model="formBranch.accurateRange"
                          :error-messages="gpsMetersRange"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md3>
                        <HelpTooltip data-name="ACCURATE_LOCATION_RANGE">
                          <span>
                            {{
                              $t(
                                'configuration.general_settings.students_requests_settings.accuracy_range_help'
                              )
                            }}
                          </span>
                        </HelpTooltip>
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-text-field
                          :label="
                            $t(
                              'configuration.general_settings.students_requests_settings.number_of_attempts'
                            )
                          "
                          type="number"
                          :suffix="
                            $t(
                              'configuration.general_settings.students_requests_settings.attempts'
                            )
                          "
                          :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                          v-model="formBranch.maxLocAttempts"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md3>
                        <HelpTooltip data-name="LOCATION_ATTEMPTS">
                          <span>
                            {{
                              $t(
                                'configuration.general_settings.students_requests_settings.number_of_attempts_help'
                              )
                            }}
                          </span>
                        </HelpTooltip>
                      </v-flex>
                    </v-layout>
                  </v-expand-transition>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>Validación de asistencia de alumno</b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      v-model="formBranch.assistanceValidation"
                      label="Activar validación de asistencia"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs2>
                    <HelpTooltip data-name="ASSISTANCE_VALIDATION">
                      <span>
                        Activa la validación de asistencia para restringir las
                        peticiones a los tutores cuando sus alumnos no estén
                        dentro del instituto.
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>Validación de asistencia de tutor</b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      v-model="formBranch.visitsEnabled"
                      label="Activar validación de asistencia"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs2>
                    <HelpTooltip data-name="VISITS_ENABLED">
                      <span>
                        Activa la validación de asistencia para restringir el
                        ingreso del tutor y solo se pueda ingresar con cita
                        previa, o desactiva
                      </span>
                      para que no sea obligatorio tener una cita.
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.school_days.school_days_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs10>
                    <v-select
                      v-model="formBranch.ableDays"
                      :items="ableDays"
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      :item-text="getLang === 'es' ? 'nombre' : 'name'"
                      item-value="id"
                      chips
                      :label="
                        $t('configuration.general_settings.school_days.days')
                      "
                      multiple
                      return-object
                      :dense="$vuetify.breakpoint.xsOnly"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <HelpTooltip data-name="ABLE_DAYS">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.school_days.school_days_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.delivery_verification.delivery_verification_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm10>
                    <v-subheader class="pl-0">
                      {{
                        $t(
                          'configuration.general_settings.delivery_verification.notification_intervals_1'
                        )
                      }}
                      {{ formBranch.pushTime }}
                      {{
                        $t(
                          'configuration.general_settings.delivery_verification.minutes'
                        )
                      }}
                    </v-subheader>
                    <v-slider
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      thumb-label
                      v-model="formBranch.pushTime"
                      min="1"
                      max="30"
                    ></v-slider>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="PUSH_VERIFICATION_TIME">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.delivery_verification.notification_intervals_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-subheader class="pl-0">
                      {{
                        $t(
                          'configuration.general_settings.delivery_verification.confirmation_waiting_time'
                        )
                      }}
                      {{ formBranch.pushTimeDeliver }}
                      {{
                        $t(
                          'configuration.general_settings.delivery_verification.minutes'
                        )
                      }}
                    </v-subheader>
                    <v-slider
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      thumb-label
                      v-model="formBranch.pushTimeDeliver"
                      min="1"
                      max="30"
                    ></v-slider>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="PUSH_VERIFICATION_TIME_DELIVER">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.delivery_verification.confirmation_waiting_time_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.hierarchy_validation.hierarchy_validation_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      v-model="formBranch.hierachyValidation"
                      :label="
                        $t(
                          'configuration.general_settings.hierarchy_validation.enable_similar_hierarchy_validation'
                        )
                      "
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="SAME_LEVEL_VALIDATION">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.hierarchy_validation.hierarchy_validation_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.authorization_of_announcements.announcement_authorization_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      v-model="formBranch.noticeModerator"
                      :label="
                        $t(
                          'configuration.general_settings.authorization_of_announcements.moderator'
                        )
                      "
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="NOTICE_MODERATOR">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.authorization_of_announcements.announcement_authorization_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                pa-3
                mt-3
                class="expandableContainer"
                style="border-radius: 5px"
              >
                <label>
                  <b>
                    {{
                      $t(
                        'configuration.general_settings.carpool_settings.carpool_settings_title'
                      )
                    }}
                  </b>
                </label>
                <v-layout row wrap>
                  <v-flex xs12 sm10>
                    <v-switch
                      :disabled="permits['UPDATE_SETTINGS'] ? false : true"
                      color="primary"
                      v-model="formBranch.roundAuth"
                      :label="
                        $t(
                          'configuration.general_settings.carpool_settings.activate_carpool_authorization'
                        )
                      "
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <HelpTooltip data-name="ROUND_AUTH">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.carpool_settings.activate_carpool_authorization_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                      :label="
                        $t(
                          'configuration.general_settings.carpool_settings.minimum_of_students_per_round'
                        )
                      "
                      type="number"
                      min="0"
                      v-model="formBranch.roundMin"
                      :suffix="
                        $t(
                          'configuration.general_settings.carpool_settings.students'
                        )
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2 offset-sm5>
                    <HelpTooltip data-name="ROUND_MIN">
                      <span>
                        {{
                          $t(
                            'configuration.general_settings.carpool_settings.students_help'
                          )
                        }}
                      </span>
                    </HelpTooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </form>
    </v-container>
    <desition
      @desition="$event ? reloadTransactions() : ''"
      v-model="modals.desition"
      title="Reinicio de entregas"
      description="¿Esta seguro que desea reiniciar las entregas del día? <br> Recuerde que esta operación es destructiva y no podrá recuperar la información eliminada."
    ></desition>
    <help
      v-model="helpDialog.flag"
      :title="helpDialog.title"
      :description="helpDialog.description"
    ></help>
    <editImage
      v-on:loaded="processImage($event)"
      v-model="modals.image"
      :title="modals.editImageTitle"
    ></editImage>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
    <success v-model="toast.success" text="Actualización Exitosa"></success>
    <confirm
      v-model="modals.desitionDelete"
      v-on:desition="deleteDoorDesition"
      title="Eliminar servidor de correo"
      description="Estas seguro que desea eliminar este servidor de correo"
    ></confirm>
    <desition1
      @desition="$event ? '' : gpsStatus()"
      v-model="toast.warning"
      :title="modals.title"
      :description="modals.message"
    />
    <desition2
      @desition="$event ? '' : arrivalStatus()"
      v-model="toast.warning1"
      :title="modals.title"
      :description="modals.message"
      :std="formBranch.requestArrival"
    />
    <qrView v-model="modals.QRcoll" :qr="qr"></qrView>
  </v-flex>
</template>

<script>
import { ableDays } from '@/Catalogs/mapSettings'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { funciones } from '../../../Mixins/Funciones.js'
import desition1 from '../../Dialogs/AlertCof.vue'
import desition2 from '../../Dialogs/AlertQRSetting.vue'
import {
  default as confirm,
  default as desition,
} from '../../Dialogs/Confirm.vue'
import error from '../../Dialogs/Error.vue'
import help from '../../Dialogs/Help.vue'
import success from '../../Dialogs/Success.vue'
import editImage from '../../Modals/EditImage_temp_500_fix_size.vue'
import profile from '../../Modals/branchModal.vue'
import qrView from '../../Modals/viewQRBranch.vue'
import HelpTooltip from './helpTooltip.vue'
export default {
  components: {
    help,
    editImage,
    desition,
    confirm,
    error,
    success,
    desition1,
    desition2,
    profile,
    qrView,
    HelpTooltip,
  },
  mixins: [funciones],
  validations: {
    formBranch: {
      name: { required },
      gpsMeters: { minValue: (value) => value > 0 },
      gpsTime: { minValue: (value) => value > 0 },
      accurateRange: {
        minValue: (value) => value > 6,
        maxValue: (value) => value <= 100,
      },
    },
    emailForm: {
      user: { required },
      port: { required },
      host: { required },
      password: { required },
      fromEmail: { required },
      protocol: { required },
    },
  },
  props: ['saveFlag', 'permits'],
  data: () => ({
    protocolItems: ['SSL', 'TLS'],
    toast: {
      fmessage: '',
      success: false,
    },
    flags: {
      updateImage: false,
      advancedOptions: false,
    },
    formBranch: {
      isStudentsActive: false,
      isCollaboratorsActive: false,
      studentsQty: '',
      collaboratorsQty: '',
      img: '',
      name: '',
      qrimg: '',
      modifyingPermit: false,
      qTime: 0,
      eTime: 0,
      allDay: false,
      gps: false,
      gps1: false,
      gpsType: '',
      gpsMeters: 0,
      gpsTime: 0,
      photoOrigin: false,
      pushTime: 0,
      accurateTimeOut: '',
      accurateRange: '',
      maxLocAttempts: '',
      studentTimeout: 1,
      hierachyValidation: false,
      ableDays: [],
      email: false,
      requestArrival: false,
      checkoutAuthorization: false,
    },
    emailForm: {
      user: '',
      port: '',
      host: '',
      password: '',
      fromEmail: '',
      protocol: '',
    },
    working: {
      wImage: false,
    },
    toast: {
      warning: false,
      warning1: false,
    },
    helpDialog: {
      title: '',
      description: '',
      flag: false,
    },
    modals: {
      title: '',
      message: '',
      image: false,
      desition: false,
      editImageTitle: '',
      desitionDelete: false,
      QRcoll: false,
    },
    modelS: false,
    modelN: false,
    modelO: false,
    qr: '',
  }),
  watch: {
    saveFlag() {
      if (this.saveFlag) {
        this.updateSettings()
      }
    },
    getBranch() {
      this.parseSettings()
    },
    permits() {
      this.$forceUpdate()
    },
    advancedOptions() {
      if (!this.advancedOptions) {
        this.formBranch.accurateTimeOut = '1'
        this.formBranch.accurateRange = '999'
        this.formBranch.maxLocAttempts = '1'
      } else {
        this.formBranch.accurateTimeOut = '8'
        this.formBranch.accurateRange = '15'
        this.formBranch.maxLocAttempts = '3'
      }
    },
  },
  mounted() {
    this.getImage()
    this.parseSettings()
    this.getSMTP()
  },
  methods: {
    qrShow() {
      this.qr = ''
      if (this.formBranch.qrimg) {
        this.qr = this.formBranch.qrimg
        this.modals.QRcoll = true
      }
    },
    gpsStatus() {
      this.formBranch.gps = true
      this.$forceUpdate()
    },
    arrivalStatus() {
      this.formBranch.requestArrival = true

      if (
        this.formBranch.requestArrival === true &&
        this.formBranch.gps === true
      ) {
        this.formBranch.gps = false
      }

      this.$forceUpdate()
    },
    filterSearch() {
      if (
        this.formBranch.requestArrival === true &&
        this.formBranch.gps === true
      ) {
        this.formBranch.requestArrival = false
      }

      if (this.formBranch.gps1 == true) {
        this.modals.title = this.$t('generic.alert')
        this.modals.message = this.$t(
          'configuration.general_settings.students_requests_settings.activate_gps_assistance_for_requests_alert'
        )
        this.toast.warning = true
      }
    },
    arrivalCond() {
      if (
        this.formBranch.requestArrival === true &&
        this.formBranch.gps === true
      ) {
        this.formBranch.gps = false
      }

      this.modals.title = this.$t('generic.alert')
      this.modals.message =
        'Escanear al llegar permite que el tutor solicite a los alumnos al llegar al colegio, justo en el momento en que realiza la lectura del QR del colegio.'
      this.toast.warning1 = true
    },
    confirmDesition() {
      this.modals.desitionDelete = true
    },
    deleteDoorDesition(event) {
      if (event) {
        this.deleteEmail()
        this.modals.desitionDelete = false
      }
    },
    deleteEmail() {
      this.$store
        .dispatch('branch/deleteEmail')
        .then(() => {
          this.parseSettings()
          this.formBranch.email = false
          this.toast.success = true
          this.modelO = false
          this.modelS = false
          this.emailForm = {
            user: '',
            port: '',
            host: '',
            password: '',
            fromEmail: '',
          }
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },
    close() {
      this.emailForm = {
        user: '',
        port: '',
        host: '',
        password: '',
        fromEmail: '',
      }
      this.$emit('input', !this.value)
    },
    submit() {
      this.$v.emailForm.$touch()
      if (!this.$v.emailForm.$invalid) {
        var obj = this.emailForm
        this.formBranch.gps1 = this.formBranch.gps
        this.formBranch.requestArrival1 = this.formBranch.requestArrival
        this.$store
          .dispatch('branch/createdSMTP', obj)
          .then(() => {
            this.$v.$reset()
            this.toast.success = true
            this.getSMTP()
            this.modelS = false
            this.formBranch.email = true
          })
          .catch((error) => {
            this.help('ERROR_SMTP')
            console.log(error)
          })
      }
    },
    test() {
      this.$v.emailForm.$touch()
      if (!this.$v.emailForm.$invalid) {
        var obj = this.emailForm
        this.$store
          .dispatch('branch/testSMTP', obj)
          .then((response) => {
            this.$v.$reset()
            this.toast.success = true
            this.$emit('created', response.data.entity)
            console.log(response)
          })
          .catch((error) => {
            this.toast.error = true
            if (error.status == 409) {
              this.toast.fmessage = error.data.message
              console.log(error)
            }
            console.log(error)
          })
      }
    },
    getSMTP() {
      var v = this
      this.$store
        .dispatch('branch/getSMTPconfig')
        .then((response) => {
          // if (response.data.id >= 2) {
          this.modelO = true
          v.emailForm.host = response.data.host
          v.emailForm.port = response.data.port
          v.emailForm.user = response.data.user
          v.emailForm.fromEmail = response.data.fromEmail
          v.emailForm.protocol = response.data.protocol
          // }
        })
        .catch((error) => {
          console.log(error)
          this.modelN = true
        })
    },
    processImage(event) {
      this.working.wImage = true
      this.formBranch.img = event.split(',')[1]
      document.getElementById(
        'img_edit_logo'
      ).innerHTML = `<img class="elevation-4" src="${event}" style='width: 120px; height: 120px; object-fit: cover; border-radius: 50%;'>`
      document.getElementById('img_edit_logo').style.display = 'block'
      document
        .getElementById('parentContainerLogoImage')
        .classList.remove('gradiente')
      document
        .getElementById('parentContainerLogoImage')
        .classList.remove('xs3')
      document
        .getElementById('parentContainerLogoImage')
        .classList.remove('xs12')
      document.getElementById('parentContainerLogoImage').classList.add('xs12')
      document.getElementById('img_edit_logo_default').style.display = 'none'
      this.working.wImage = false
    },
    parseSettings() {
      if (this.getBranch.settings === undefined) return

      this.formBranch.img = this.getBranch.img
      this.formBranch.name = this.getBranch.name
      if (this.getBranch.qrImageStorage) {
        this.formBranch.qrimg = this.getBranch.qrImageStorage.miniObjUrl
      }
      const options = {
        studentsManualEntryEnabled: 'STUDENT_MANUAL_ENTRY_LIMIT_ENABLED',
        collabsManualEntryEnabled: 'COLLABORATOR_MANUAL_ENTRY_LIMIT_ENABLED',
        studentsManualEntryQty: 'STUDENT_MANUAL_ENTRY_LIMIT_SIZE',
        collabsManualEntryQty: 'COLLABORATOR_MANUAL_ENTRY_LIMIT_SIZE',
      }

      for (var s in this.getBranch.settings) {
        switch (this.getBranch.settings[s].name) {
          case options.studentsManualEntryEnabled:
            this.formBranch.isStudentsActive =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case options.collabsManualEntryEnabled:
            this.formBranch.isCollaboratorsActive =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case options.studentsManualEntryQty:
            this.formBranch.studentsQty = this.getBranch.settings[s].value
            break
          case options.collabsManualEntryQty:
            this.formBranch.collaboratorsQty = this.getBranch.settings[s].value
            break
          case 'MODIFYING_PERMIT':
            this.formBranch.modifyingPermit =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'Q_TIME':
            this.formBranch.qTime = parseInt(this.getBranch.settings[s].value)
            break
          case 'E_TIME':
            this.formBranch.eTime = parseInt(this.getBranch.settings[s].value)
            break
          case 'GPS_DELIVERY':
            this.formBranch.gps =
              this.getBranch.settings[s].value == 'YES' ? true : false

            this.formBranch.gps1 =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'GPS_TIME_OR_DISTANCE':
            this.formBranch.gpsType = this.getBranch.settings[s].value
            break
          case 'GPS_METERS':
            this.formBranch.gpsMeters = parseInt(
              this.getBranch.settings[s].value
            )
            break
          case 'GPS_TIME':
            this.formBranch.gpsTime = parseInt(this.getBranch.settings[s].value)
            break
          case 'PHOTO_ORIGIN':
            this.formBranch.photoOrigin =
              this.getBranch.settings[s].value == 'parent' ? true : false
            break
          case 'PUSH_VERIFICATION_TIME':
            this.formBranch.pushTime = parseInt(
              this.getBranch.settings[s].value
            )
            break
          case 'PUSH_VERIFICATION_TIME_DELIVER':
            this.formBranch.pushTimeDeliver = parseInt(
              this.getBranch.settings[s].value
            )
            break
          case 'SAME_LEVEL_VALIDATION':
            this.formBranch.hierachyValidation =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'NOTICE_MODERATOR':
            this.formBranch.noticeModerator =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'ROUND_AUTH':
            this.formBranch.roundAuth =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'ROUND_MIN':
            this.formBranch.roundMin = parseInt(
              this.getBranch.settings[s].value
            )
            break
          case 'ASSISTANCE_VALIDATION':
            this.formBranch.assistanceValidation =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'CHECKOUT_AUTHORIZATION':
            this.formBranch.checkoutAuthorization =
              this.getBranch.settings[s].value === 'YES'
            break
          case 'VISITS_ENABLED':
            this.formBranch.visitsEnabled =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
          case 'ACCURATE_LOCATION_TIME_OUT':
            this.formBranch.accurateTimeOut = this.getBranch.settings[s].value
            break
          case 'ACCURATE_LOCATION_RANGE':
            this.formBranch.accurateRange = this.getBranch.settings[s].value
            break
          case 'LOCATION_ATTEMPTS':
            this.formBranch.maxLocAttempts = this.getBranch.settings[s].value
            break
          case 'STUDENT_DELIVER_TIMEOUT':
            this.formBranch.studentTimeout = this.getBranch.settings[s].value
            break
          case 'USE_CUSTOM_SMTP':
            this.formBranch.email =
              this.getBranch.settings[s].value == 'YES' ? true : false
            // if(this.getBranch.settings[s].value == "YES"){
            // this.getSMTP();
            // }
            break
          case 'REQUEST_UPON_ARRIVAL':
            this.formBranch.requestArrival =
              this.getBranch.settings[s].value == 'YES' ? true : false
            this.formBranch.requestArrival1 =
              this.getBranch.settings[s].value == 'YES' ? true : false
            break
        }

        this.formBranch.ableDays = this.getBranch.ableDays
        if (this.formBranch.qTime == 719 && this.formBranch.eTime == 719) {
          this.formBranch.allDay = true
        }
      }
    },
    help(type) {
      switch (type) {
        case 'SAME_LEVEL_VALIDATION':
          this.helpDialog.title = 'Validación de jerarquía similar'
          this.helpDialog.description =
            'El usuario puede actualizar y/o eliminar otros usuarios que posean un rol con una jerarquía igual o menor a la de él.'
          this.helpDialog.flag = true
          break
        case 'PUSH_VERIFICATION_TIME':
          this.helpDialog.title = 'Verificación de entrega'
          this.helpDialog.description =
            'Controla el intervalo de tiempo en el que la notificación de verificación se muestra al tutor.'
          this.helpDialog.flag = true
          break
        case 'PUSH_VERIFICATION_TIME_DELIVER':
          this.helpDialog.title = 'Tiempo de confirmación de la entrega'
          this.helpDialog.description =
            'Configura el lapso de tiempo que tiene el tutor para confirmar que su alumno se encuentra con él, antes de entregarlo automáticamente.'
          this.helpDialog.flag = true
          break
        case 'ABLE_DAYS':
          this.helpDialog.title = 'Días hábiles'
          this.helpDialog.description =
            'Selecciona los días hábiles en los que tu institución permitirá la solicitud de los alumnos.'
          this.helpDialog.flag = true
          break
        case 'GPS_TIME_OR_DISTANCE':
          if (this.formBranch.gpsType == 'time') {
            this.helpDialog.title = 'GPS basado en tiempo'
            this.helpDialog.description =
              'Permite a los tutores realizar peticiones a ciertos minutos de distancia del colegio.'
          } else {
            this.helpDialog.title = 'GPS basado en distancia'
            this.helpDialog.description =
              'Permite a los tutores realizar peticiones a ciertos metros de distancia del colegio.'
          }
          this.helpDialog.flag = true
          break
        case 'GPS_DELIVERY':
          this.helpDialog.title = 'Asistencia GPS'
          this.helpDialog.description =
            'La asistencia de GPS permite que las solicitudes se realicen dependiendo de la ubicación del tutor.'
          this.helpDialog.flag = true
          break
        case 'REQUEST_UPON_ARRIVAL':
          this.helpDialog.title = 'Solicitar al llegar'
          this.helpDialog.description =
            'Esta opción determina que los tutores deben de escanear un código QR del colegio para poder solicitar a los alumnos.'
          this.helpDialog.flag = true
          break
        case 'Q_TIME':
          this.helpDialog.title = 'Rango inicial'
          this.helpDialog.description =
            'Tiempo en minutos para solicitar alumnos <b>ANTES</b> de la hora de salida.<br><br>Ejemplo 120 mins = 2hrs'
          this.helpDialog.flag = true
          break
        case 'E_TIME':
          this.helpDialog.title = 'Rango final'
          this.helpDialog.description = `Tiempo máximo en minutos para solicitar alumnos <b>DESPUÉS</b> de la hora de salida.<br><br>Ejemplo 120 mins = 2hrs`
          this.helpDialog.flag = true
          break
        case 'ALL_DAY':
          this.helpDialog.title = 'Peticiones'
          this.helpDialog.description = `Controla el tiempo en el que los tutores pueden pedir a sus hijos:<br><ul><li><b>Todo el día</b>: Los tutores pueden pedir a sus hijos a cualquier hora</li><li><b>Especificar</b>: Los tutores solo pueden pedir a sus hijos en un rango determinado</li></ul>`
          this.helpDialog.flag = true
          break
        case 'PHOTO_ORIGIN':
          this.helpDialog.title = 'Edición de foto del alumno'
          this.helpDialog.description = `Permite a los tutores editar la foto de perfil de sus hijos.`
          this.helpDialog.flag = true
          break
        case 'MODIFYING_PERMIT':
          this.helpDialog.title = 'Edición de información de perfil'
          this.helpDialog.description = `Permite a los tutores editar su información de perfil.`
          this.helpDialog.flag = true
          break
        case 'NOTICE_MODERATOR':
          this.helpDialog.title = 'Moderador de comunicados'
          this.helpDialog.description = `Añade un nivel de seguridad al requerir la autorización del instituto para publicar comunicados.`
          this.helpDialog.flag = true
          break
        case 'ROUND_AUTH':
          this.helpDialog.title = 'Autorización de rondas'
          this.helpDialog.description = `Añade un nivel de seguridad al requerir la autorización del instituto para la creación de rondas.`
          this.helpDialog.flag = true
          break
        case 'ROUND_MIN':
          this.helpDialog.title = 'Mínimo de alumnos'
          this.helpDialog.description = `Establece un mínimo de alumnos necesario para crear un ronda.`
          this.helpDialog.flag = true
          break
        case 'ASSISTANCE_VALIDATION':
          this.helpDialog.title = 'Validación de asistencia de alumno'
          this.helpDialog.description = `Activa la validación de asistencia para restringir las peticiones a los tutores cuando sus alumnos no estén dentro del instituto.`
          this.helpDialog.flag = true
          break
        case 'VISITS_ENABLED':
          this.helpDialog.title = 'Validación de asistencia de tutor'
          this.helpDialog.description = `Activa la validación de asistencia para restringir el ingreso del tutor y solo se pueda ingresar con cita previa, o desactiva para que no sea obligatorio tener una cita.`
          this.helpDialog.flag = true
          break
        case 'ACCURATE_LOCATION_TIME_OUT':
          this.helpDialog.title = 'Tiempo máximo de espera'
          this.helpDialog.description = `Tiempo máximo de espera para obtener una respuesta de la cuadratura por satélite.`
          this.helpDialog.flag = true
          break
        case 'ACCURATE_LOCATION_RANGE':
          this.helpDialog.title = 'Rango de presición'
          this.helpDialog.description = `Establece un rango mínimo aceptado para la respuesta de la localización.`
          this.helpDialog.flag = true
          break
        case 'LOCATION_ATTEMPTS':
          this.helpDialog.title = 'Número de intentos'
          this.helpDialog.description = `Establece un mínimo aceptado de intentos para una respuesta satisfactoria de la localización.`
          this.helpDialog.flag = true
          break
        case 'STUDENT_DELIVER_TIMEOUT':
          this.helpDialog.title = 'Tiempo para volver a pedir'
          this.helpDialog.description = `Establece un tiempo determinado, para volver a pedir al alumno.`
          this.helpDialog.flag = true
          break
        case 'USE_CUSTOM_SMTP':
          this.helpDialog.title = 'Configuración de correo'
          this.helpDialog.description = `Configura la cuenta de correos con los que se enviarán los correos de bienvenida a los tutores y colaboradores una vez que se den de alta.`
          this.helpDialog.flag = true
          break
        case 'ERROR_SMTP':
          this.helpDialog.title = 'Configuración de correo'
          this.helpDialog.description = `Error en credenciales`
          this.helpDialog.flag = true
          break
      }
    },
    getImage() {
      this.working.wImage = true
      this.$store
        .dispatch('branch/updateImageBranch')
        .then((response) => {
          this.working.wImage = false

          const imageStorageDoesExist =
            response.data.entity.imageStorage !== undefined

          if (imageStorageDoesExist) {
            const urlPath = response.data.entity.imageStorage.miniObjUrl
            document.getElementById(
              'img_edit_logo'
            ).innerHTML = `<img	class="elevation-4" src="${urlPath}" style='width: 120px; height: 120px; object-fit: cover; border-radius: 50%;'>`
            document.getElementById('img_edit_logo').style.display = 'block'
            document
              .getElementById('parentContainerLogoImage')
              .classList.remove('gradiente')
            document
              .getElementById('parentContainerLogoImage')
              .classList.remove('xs3')
            document
              .getElementById('parentContainerLogoImage')
              .classList.add('xs12')
            document.getElementById('img_edit_logo_default').style.display =
              'none'
            this.formBranch.img = urlPath
          }
        })
        .catch((error) => {
          this.working.wImage = false
          console.log(error)
        })
    },
    updateSettings() {
      const isLogoUpdated = !(
        this.formBranch.img === null ||
        this.formBranch.img === '' ||
        this.formBranch.img === undefined ||
        this.formBranch.img.includes('https://')
      )

      this.$v.formBranch.$touch()
      if (!this.$v.formBranch.$invalid) {
        this.$emit('wBranch', true)
        this.formBranch.id = this.getBranch.id
        var settings = this.formatSettings()
        var branch = {
          id: this.formBranch.id,
          name: this.formBranch.name,
          img: isLogoUpdated === true ? this.formBranch.img : null,
          ableDays: this.formBranch.ableDays,
          settings: settings,
        }
        var json = JSON.stringify(branch) // aqui tienes la lista de objetos en Json
        var obj = JSON.parse(json)
        this.$store
          .dispatch('branch/updateBranch', obj)
          .then(() => {
            this.updateBranch()
            this.getImage()
            this.$emit('wBranch', false)
            this.$emit('success', true)
          })
          .catch(() => {
            this.$emit('wBranch', false)
            this.$emit('failed', true)
          })
      } else {
        this.$emit('wBranch', false)
      }
    },
    // METHOD SIMILAR LIKE THE ONE IN THE PANEL SCREEN
    updateBranch() {
      this.$store.dispatch('branch/getBrand').then((response) => {
        const brand = response.data.entity

        for (var branch in brand.branches) {
          if (brand.branches[branch].id == this.getUser.branch.id) {
            const imageStorageDoesExist =
              brand.branches[branch].imageStorage !== undefined

            this.$store.commit('updateBranch', {
              branch: {
                ...brand.branches[branch],
                img: imageStorageDoesExist
                  ? brand.branches[branch].imageStorage.miniObjUrl
                  : null,
              },
            })
          }
        }
      })
    },
    formatSettings() {
      if (this.getBranch.settings === undefined) return

      const options = {
        studentsManualEntryEnabled: 'STUDENT_MANUAL_ENTRY_LIMIT_ENABLED',
        collabsManualEntryEnabled: 'COLLABORATOR_MANUAL_ENTRY_LIMIT_ENABLED',
        studentsManualEntryQty: 'STUDENT_MANUAL_ENTRY_LIMIT_SIZE',
        collabsManualEntryQty: 'COLLABORATOR_MANUAL_ENTRY_LIMIT_SIZE',
      }

      let settings = []
      for (var s in this.getBranch.settings) {
        let setting
        switch (this.getBranch.settings[s].name) {
          case options.studentsManualEntryEnabled:
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.isStudentsActive ? 'YES' : 'NO'
            settings.push(setting)
            break
          case options.collabsManualEntryEnabled:
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.isCollaboratorsActive ? 'YES' : 'NO'
            settings.push(setting)
            break
          case options.studentsManualEntryQty:
            setting = this.getBranch.settings[s]
            setting.value =
              this.formBranch.studentsQty === ''
                ? '0'
                : this.formBranch.studentsQty
            settings.push(setting)
            break
          case options.collabsManualEntryQty:
            setting = this.getBranch.settings[s]
            setting.value =
              this.formBranch.collaboratorsQty === ''
                ? '0'
                : this.formBranch.collaboratorsQty
            settings.push(setting)
            break
          case 'MODIFYING_PERMIT':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.modifyingPermit ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'Q_TIME':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.allDay
              ? '719'
              : this.formBranch.qTime + ''
            settings.push(setting)
            break
          case 'E_TIME':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.allDay
              ? '719'
              : this.formBranch.eTime + ''
            settings.push(setting)
            break
          case 'GPS_DELIVERY':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.gps ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'GPS_TIME_OR_DISTANCE':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.gpsType
            settings.push(setting)
            break
          case 'GPS_METERS':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.gpsMeters + ''
            settings.push(setting)
            break
          case 'GPS_TIME':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.gpsTime + ''
            settings.push(setting)
            break
          case 'PHOTO_ORIGIN':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.photoOrigin ? 'parent' : 'system'
            settings.push(setting)
            break
          case 'PUSH_VERIFICATION_TIME':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.pushTime + ''
            settings.push(setting)
            break
          case 'PUSH_VERIFICATION_TIME_DELIVER':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.pushTimeDeliver + ''
            settings.push(setting)
            break
          case 'SAME_LEVEL_VALIDATION':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.hierachyValidation ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'NOTICE_MODERATOR':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.noticeModerator ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'ROUND_AUTH':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.roundAuth ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'ROUND_MIN':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.roundMin
            settings.push(setting)
            break
          case 'ASSISTANCE_VALIDATION':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.assistanceValidation ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'CHECKOUT_AUTHORIZATION':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.checkoutAuthorization ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'VISITS_ENABLED':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.visitsEnabled ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'ACCURATE_LOCATION_TIME_OUT':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.accurateTimeOut
            settings.push(setting)
            break
          case 'ACCURATE_LOCATION_RANGE':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.accurateRange
            settings.push(setting)
            break
          case 'LOCATION_ATTEMPTS':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.maxLocAttempts
            settings.push(setting)
            break
          case 'STUDENT_DELIVER_TIMEOUT':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.studentTimeout
            settings.push(setting)
            break
          case 'USE_CUSTOM_SMTP':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.email ? 'YES' : 'NO'
            settings.push(setting)
            break
          case 'REQUEST_UPON_ARRIVAL':
            setting = this.getBranch.settings[s]
            setting.value = this.formBranch.requestArrival ? 'YES' : 'NO'
            settings.push(setting)
            break
        }
      }
      return settings
    },
    reloadTransactions() {
      this.$emit('wBranch', true)
      this.$store
        .dispatch('request/resetTransactions')
        .then(() => {
          this.$emit('wBranch', false)
          this.$emit('success', true)
        })
        .catch(() => {
          this.$emit('wBranch', false)
          this.$emit('failed', true)
        })
    },
  },
  computed: {
    ableDays() {
      return ableDays
    },
    gpsTimeErrors() {
      const errors = []
      if (this.formBranch.gpsType == 'time') {
        if (!this.$v.formBranch.name.$dirty) return errors
        !this.$v.formBranch.gpsTime.minValue &&
          errors.push('El tiempo debe ser mayor a 1 minuto')
      }
      return errors
    },
    gpsMetersErrors() {
      const errors = []
      if (this.formBranch.gpsType == 'distance') {
        if (!this.$v.formBranch.name.$dirty) return errors
        !this.$v.formBranch.gpsMeters.minValue &&
          errors.push('La distancia debe ser mayor a 1 metro')
      }
      return errors
    },
    gpsMetersRange() {
      const errors = []
      if (!this.$v.formBranch.accurateRange.$dirty) return errors
      if (
        !this.$v.formBranch.accurateRange.minValue ||
        !this.$v.formBranch.accurateRange.maxValue
      ) {
        errors.push('La distancia debe ser mayor a 6 metros y menor de 100')
      }
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.formBranch.name.$dirty) return errors
      !this.$v.formBranch.name.required &&
        errors.push('Nombre de la institución requerido')
      return errors
    },
    processErrorName() {
      const errors = []
      if (!this.$v.brandForm.name.$dirty) return errors
      !this.$v.brandForm.name.required && errors.push('El nombre es requerido')
      return errors
    },
    processErrorPhone() {
      const errors = []
      if (!this.$v.brandForm.phone.$dirty) return errors
      !this.$v.brandForm.phone.required &&
        errors.push('El teléfono es requerido')
      return errors
    },
    userErrors() {
      const errors = []
      if (!this.$v.emailForm.user.$dirty) return errors
      !this.$v.emailForm.user.required && errors.push('Nombre obligatorio')
      return errors
    },
    portErrors() {
      const errors = []
      if (!this.$v.emailForm.port.$dirty) return errors
      !this.$v.emailForm.port.required && errors.push('Puerto obligatorio')
      return errors
    },
    hostErrors() {
      const errors = []
      if (!this.$v.emailForm.host.$dirty) return errors
      !this.$v.emailForm.host.required && errors.push('Host obligatorio')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.emailForm.password.$dirty) return errors
      !this.$v.emailForm.password.required &&
        errors.push('Contraseña obligatoria')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.emailForm.fromEmail.$dirty) return errors
      !this.$v.emailForm.fromEmail.required && errors.push('Correo obligatorio')
      return errors
    },
    //Mappers
    ...mapGetters(['getBranch', 'getUser', 'getLang']),
  },
}
</script>

<style>
.helpButton {
  font-size: 20px !important;
}
</style>
<style scoped>
::v-deep .v-input__control {
  width: 100% !important;
}
</style>
